const FlexibleStaffingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.0182 62.3606C42.4976 62.3606 42.0756 61.9386 42.0756 61.418V59.7701C42.0756 56.1954 39.6542 53.0903 36.1872 52.2192L28.9594 50.4031C28.0681 50.1791 27.4329 49.4078 27.3751 48.5011C27.1779 48.9354 26.9701 49.3735 26.7542 49.8016C25.2172 52.8504 23.859 54.2703 22.4802 54.2703C21.9596 54.2703 21.5376 53.8483 21.5376 53.3277C21.5376 52.8071 21.9596 52.3851 22.4802 52.3851C22.4888 52.3851 23.3602 52.3458 25.0708 48.9529C26.1071 46.8977 26.9561 44.5869 27.273 43.6888C27.4384 43.2189 27.9165 42.9384 28.4068 43.0227C28.8989 43.1068 29.2559 43.5302 29.2559 44.0293V48.3657C29.2559 48.4646 29.3229 48.5506 29.4187 48.5746L36.6467 50.3907C40.9532 51.4729 43.9608 55.3298 43.9608 59.7701V61.418C43.9608 61.9386 43.5388 62.3606 43.0182 62.3606Z"
        fill="#027C80"
      />
      <path
        d="M1.94262 62.3527C1.422 62.3527 1 61.9307 1 61.41V59.7623C1 55.3223 3.99697 51.4654 8.2882 50.3831L15.4884 48.567C15.583 48.5432 15.649 48.4571 15.649 48.3577V44.0214C15.649 43.5219 16.0062 43.0986 16.4984 43.0147C16.9897 42.9311 17.4665 43.2117 17.6318 43.6823C17.9473 44.5799 18.793 46.8904 19.8256 48.9462C21.5289 52.3379 22.3938 52.3772 22.4024 52.3772C22.923 52.3772 23.345 52.7992 23.345 53.3198C23.345 53.8404 22.923 54.2624 22.4024 54.2624C21.0267 54.2624 19.6725 52.842 18.1409 49.7924C17.9282 49.369 17.7233 48.9361 17.529 48.5066C17.466 49.4072 16.8342 50.1719 15.9495 50.395L8.74925 52.2111C5.29662 53.082 2.88524 56.1871 2.88524 59.7623V61.41C2.88524 61.9307 2.46324 62.3527 1.94262 62.3527Z"
        fill="#027C80"
      />
      <path
        d="M22.3917 58.986C16.3067 58.986 13.4014 50.5324 13.2806 50.1725C13.1151 49.6789 13.381 49.1446 13.8746 48.979C14.368 48.8138 14.9019 49.0791 15.0678 49.5723C15.0932 49.6476 17.6617 57.1007 22.3917 57.1007C24.3325 57.1007 26.1585 55.8648 27.8193 53.4273C29.1251 51.5106 29.7996 49.5836 29.8062 49.5644C29.9765 49.0725 30.5122 48.8112 31.0054 48.982C31.4973 49.1523 31.7581 49.6891 31.5878 50.1811C31.4633 50.5406 28.4701 58.986 22.3917 58.986Z"
        fill="#027C80"
      />
      <path
        d="M36.537 26.9861C36.0164 26.9861 35.5944 26.5641 35.5944 26.0435V18.5123C35.5944 17.9506 35.1374 17.4937 34.5758 17.4937C33.3611 17.4937 32.3728 16.5054 32.3728 15.2907C32.3728 12.4264 30.0426 10.0962 27.1784 10.0962H20.6514C14.343 10.0962 9.21068 15.2286 9.21068 21.5371V25.7311C9.21068 26.2517 8.78868 26.6737 8.26806 26.6737C7.74744 26.6737 7.32544 26.2517 7.32544 25.7311V21.5371C7.32544 14.189 13.3035 8.21094 20.6514 8.21094H27.1784C31.0821 8.21094 34.2581 11.3869 34.2581 15.2907C34.2581 15.4659 34.4006 15.6084 34.5758 15.6084C36.177 15.6084 37.4796 16.911 37.4796 18.5123V26.0435C37.4796 26.5641 37.0577 26.9861 36.537 26.9861Z"
        fill="#027C80"
      />
      <path
        d="M34.7049 35.1014H34.5183C33.9977 35.1014 33.5757 34.6794 33.5757 34.1587C33.5757 33.6381 33.9977 33.2161 34.5183 33.2161H34.7049C36.5901 33.2161 38.1239 31.842 38.1239 30.153V29.4797C38.1239 27.7906 36.5901 26.4165 34.7049 26.4165C34.1843 26.4165 33.7623 25.9945 33.7623 25.4739C33.7623 24.9533 34.1843 24.5312 34.7049 24.5312C37.6297 24.5312 40.0091 26.7511 40.0091 29.4797V30.153C40.0091 32.8816 37.6297 35.1014 34.7049 35.1014Z"
        fill="#FFA473"
      />
      <path
        d="M10.1421 35.1014H9.96269C7.13049 35.1014 4.82642 32.8816 4.82642 30.153V29.4797C4.82642 26.7511 7.13049 24.5312 9.96269 24.5312C10.4833 24.5312 10.9053 24.9533 10.9053 25.4739C10.9053 25.9945 10.4833 26.4165 9.96269 26.4165C8.17003 26.4165 6.71165 27.7906 6.71165 29.4797V30.153C6.71165 31.842 8.17003 33.2161 9.96269 33.2161H10.1421C10.6627 33.2161 11.0847 33.6381 11.0847 34.1587C11.0847 34.6794 10.6627 35.1014 10.1421 35.1014Z"
        fill="#FFA473"
      />
      <path
        d="M22.4416 45.6855C15.14 45.6855 9.19971 39.7451 9.19971 32.4433V26.0991C9.19971 26.0362 9.2001 25.9734 9.20115 25.9106C9.21365 25.044 9.51032 24.1853 10.0365 23.494L12.1467 20.7215C12.8642 19.7792 14.0974 19.4075 15.2163 19.7962L18.0135 20.7687C20.9005 21.7725 24.0903 21.8027 26.9959 20.8544L30.4364 19.7312C31.5125 19.3799 32.6793 19.8071 33.2745 20.7695L34.9898 23.5434C35.4306 24.2559 35.67 25.0752 35.6822 25.9127C35.6831 25.9753 35.6836 26.0371 35.6836 26.0991V32.4433C35.6836 39.7451 29.7432 45.6855 22.4416 45.6855ZM14.3188 21.5297C14.0601 21.5297 13.8102 21.6488 13.6469 21.8634L11.5367 24.6358C11.2529 25.0086 11.093 25.4715 11.0861 25.9392C11.0853 25.9934 11.0849 26.0462 11.0849 26.0991V32.4433C11.0849 38.7056 16.1795 43.8002 22.4416 43.8002C28.7038 43.8002 33.7984 38.7056 33.7984 32.4433V26.0991C33.7984 26.0458 33.7979 25.9925 33.7972 25.9394C33.79 25.4436 33.648 24.9577 33.3865 24.5351L31.6712 21.7611C31.5348 21.5407 31.2678 21.443 31.0213 21.5235L27.5808 22.6465C24.2857 23.7222 20.668 23.6876 17.3944 22.5494L14.5971 21.5769C14.5056 21.5451 14.4116 21.5297 14.3188 21.5297Z"
        fill="#FFA473"
      />
      <path
        d="M51.4651 24.0702C57.8356 24.0702 62.9999 18.9057 62.9999 12.5351C62.9999 6.16443 57.8356 1 51.4651 1C45.0945 1 39.9302 6.16443 39.9302 12.5351C39.9302 18.9057 45.0945 24.0702 51.4651 24.0702Z"
        stroke="#027C80"
        strokeWidth="1.15929"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.5535 12.4688H42.249"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8523 17.4337L43.4547 17.0859"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.4592 21.0946L46.807 20.4922"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.407 22.4456V21.75"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.3707 21.1415L56.0229 20.5391"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.0199 17.5353L59.4175 17.1875"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.3767 12.5938H60.6812"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.078 7.625L59.4756 7.97279"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.4713 3.97656L56.1235 4.57895"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5232 2.61719V3.31277"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.5591 3.91406L46.9069 4.51645"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9102 7.53125L43.5125 7.87904"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5232 12.4752V5.86719"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.8299 14.8055L51.6182 12.5938"
        stroke="#06AEB3"
        strokeWidth="1.15929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FlexibleStaffingIcon;
